export default {
	data() {
		return {
			moduleName: 'billers',
			detailPageRouteName: 'billerDetail',
			entity: {id_operator: null, address: {country: 'CZE'}, subject_type: 'person', tag_ids: [],},
			updateFields: [
				'firstname', 'surname', 'id_operator', 'subject_type', 'company_name', 'cin', 'tin',
				'email', 'phone', 'address', 'note', "tag_ids"
			],
			ownId: null,
		}
	},
	methods: {
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
				allowed['id_remote'] = this.ownId
			}.bind(this))
			return allowed
		},
		setOwnId(value) {
			this.ownId = value
		},
		resetFields() {
			this.$refs['billerformref'].validateBillerFormRequiredFields()
			this.$refs['billerformref'].$refs['surnameref'].setTouched(false)
			this.$refs['billerformref'].$refs['firstnameref'].setTouched(false)
		},
		processErrorMessage(error) {
			this.$refs['billerformref'].validateBillerFormRequiredFields()
			return error['error_message']
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				if (this._.includes(errorMessage, 'Unable to delete Biller') &&
					this._.includes(errorMessage, 'subscribers with given biller')) {
					deleteError = this.$gettext('Není možné smazat plátce pokud je přiřazen k odběrateli.')
				}
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/billers/mixins/billers.js